import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import ASSETS from '../assets';

const NavConfig = [
  {
    label: 'Home',
    path: '/',
  },
  {
    label: 'Transactions',
    path: '/transactions',
  },
  {
    label: 'Blocks',
    path: '/blocks',
  },
  {
    label: 'Accounts',
    path: '/accounts',
  },
  {
    label: 'SDK Documentation',
    path: '/sdk',
  },
];

const MainLayout = () => {
  return (
    <div className='h-[100dvh] flex flex-col'>
      <header className='sticky shadow-navbar flex items-center h-[54px] bg-white justify-between px-10'>
        <div className='flex items-center gap-12'>
          <Link to='/'>
            <img src={ASSETS.logo} alt='' />
          </Link>
          <div className='flex items-center min-w-[400px] border border-bryt-grey-200 h-[38px] rounded-lg'>
            <input
              type='search'
              name=''
              className='flex-grow outline-none border-none px-[10px] h-full text-sm rounded-lg'
              id=''
              placeholder='Search...'
            />
            <img src={ASSETS.searchGrey} className='mr-3' alt='' />
          </div>
        </div>
        <div className='flex items-center gap-[30px]'>
          {NavConfig.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                isActive
                  ? 'text-[14.5px] text-bryt-primary-light cursor-pointer'
                  : 'text-[14.5px] hover:text-bryt-primary-light cursor-pointer'
              }
            >
              {item.label}
            </NavLink>
          ))}

          <div className='w-[1px] h-[10px] bg-'></div>
          <div className='flex items-center gap-1'>
            <img src={ASSETS.user} alt='' />
            <p className='text-[14.5px]'> Sign In</p>
          </div>
        </div>
      </header>
      <main className='flex-grow overflow-auto h-0 bg-white flex flex-col'>
        <Outlet />
        <footer className='mt-auto bg-footer px-[30px] pt-10 flex flex-col items-center'>
          <img src={ASSETS.logo} className='w-[236px]' alt='' />
          <div className='flex items-center gap-[50px] mt-[18px] mb-9'>
            <p className='text-base text-bryt-primary-main cursor-pointer'>
              About Us
            </p>
            <p className='text-base text-bryt-primary-main cursor-pointer'>
              Remittance & Payments
            </p>
            <p className='text-base text-bryt-primary-main cursor-pointer'>
              Security
            </p>
            <p className='text-base text-bryt-primary-main cursor-pointer'>
              Contact
            </p>
            <p className='text-base text-bryt-primary-main cursor-pointer'>
              FAQ
            </p>
          </div>
          <div className='h-[1px] w-full bg-white'></div>
          <p className='text-base text-bryt-primary-main my-5'>
            Copyright © BRYT. All Rights Reserved
          </p>
        </footer>
      </main>
    </div>
  );
};

export default MainLayout;
